import React, { Component } from 'react';
import Version from "../version";
import { Grid } from "@material-ui/core";
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import { TextField, TextFieldLowerCase } from '../controls/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import theme from '../theme';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);



class ChangeAddress extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeAddress", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg:
            {
                SubscriptionNo: props.SubscriptionNo,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            CustomerType: '10',
            CompanyName: '',
            OrgNo: '',
            Firstname: '',
            Lastname: '',
            Birthdate: '',
            CoAddress: '',
            AddressLine: '',
            PostalCode: '',
            City: '',
            EmailAddress: '',
            ContactPhone: '',
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
            EnterLastDigitsDialogOpen: false,
            LastDigits: '',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changeregistered'),
                html: this.props.t('selfcare:notification.addressupdatedwithinminutes'),
                icon: 'success',
                confirmButtonColor: theme.palette.primary.main,
            }).then((result) => {
                this.props.handleClose();
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changefailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: theme.palette.primary.main,
            });
            this.setState({ buzy: false });
        }
        if (nextState.GeneralError && !this.state.GeneralError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.technicalerror'),
                html: nextState.GeneralError,
                icon: 'error',
                confirmButtonColor: theme.palette.primary.main,
            });
            this.setState({ buzy: false });
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        switch (nextState.Message.Action) {
                            case 'close':
                                if (this.props.handleRefresh)
                                    this.props.handleRefresh();
                                if (this.props.handleClose)
                                    this.props.handleClose();
                                break;
                            case 'none':
                                break;
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'redirect':
                                window.location.assign(nextState.Message.ActionParam);
                                break;
                            default:
                                break;
                        }
                    });
                }.bind(this),
                10
            );
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    setFocus = fieldName => {
        switch (fieldName) {
            case "ContactPhone":
                if (this.ContactPhone) {
                    setTimeout(() => {
                        this.ContactPhone.focus();
                    }, 10);
                }
                break;
            case "EmailAddress":
                if (this.EmailAddress) {
                    setTimeout(() => {
                        this.EmailAddress.focus();
                    }, 10);
                }
                break;
            case "CoAddress":
                if (this.CoAddress) {
                    setTimeout(() => {
                        this.CoAddress.focus();
                    }, 10);
                }
                break;
            case "AddressLine":
                if (this.AddressLine) {
                    setTimeout(() => {
                        this.AddressLine.focus();
                    }, 10);
                }
                break;
            case "PostalCode":
                if (this.PostalCode) {
                    setTimeout(() => {
                        this.PostalCode.focus();
                    }, 10);
                }
                break;
            case "LastDigits":
                if (this.LastDigits) {
                    setTimeout(() => {
                        this.LastDigits.focus();
                    }, 10);
                }
                break;
            default:
                break;
        }
    }
    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
        if (name === 'PostalCode') {
            this.dispatchState({ Lookup: event.target.value });
        }
    }

    handleSave = () => {
        this.setState({ buzy: true, ErrorField: '' });
        this.dispatchState({ PerformChange: { Firstname: this.state.Firstname, Lastname: this.state.Lastname, CoAddress: this.state.CoAddress, AddressLine: this.state.AddressLine, PostalCode: this.state.PostalCode, EmailAddress: this.state.EmailAddress, ContactPhone: this.state.ContactPhone } });
    }
    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        const classes = this.props;
        const { t } = this.props;
        const postcodelen = this.state.IsSweden ? 5 : 4;
        return (
            <div style={{ height: '100vh' }}>
                <Dialog
                    open={this.state.EnterLastDigitsDialogOpen}
                    onClose={() => { this.setState({ EnterLastDigitsDialogOpen: false, buzy: false }); }}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <div style={{ display: 'flex' }}>
                            <Icon name="edit" size={36} color="#e91e63" />
                            <span style={{ marginLeft: '20px', fontWeight: '700' }}>Sjekk med fødselsnummer</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        Ingen eller flere treff funnet i folkeregisteret<br /><br />
                        Du kan fullføre fødselsdatoen din med de fem siste sifrene og prøve igjen<br />
                        <Grid container direction="row" alignItems="center" justifyContent="center">
                            <Grid item style={{ fontSize: '1rem', textAlign: 'right' }} xs={6}>
                                {this.state.SsnStart} -&nbsp;
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth
                                    autoFocus
                                    disabled={this.state.buzy || this.state.Disabled}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label="Siste 5 sifrene"
                                    id="LastDigits"
                                    name="LastDigits"
                                    type='tel'
                                    maxLength={5}
                                    labelWidth="150px"
                                    inputRef={(el) => { this.LastDigits = el; }}
                                />
                            </Grid>
                        </Grid>
                        {this.state.AddressLookupErrorText && <div style={{ width: '100%', padding: '5px', color: '#e91e63', fontSize: '12px' }}>{this.state.AddressLookupErrorText}</div>}
                    </DialogContent>
                    <DialogActions>
                        <LargeButton onClick={() => { this.setState({ AddressLookupErrorText: '' }); this.dispatchState({ SetLastDigits: this.state.LastDigits }); }}>
                            OK
                        </LargeButton>
                        <LargeButton color="secondary" variant="text" onClick={() => { this.setState({ EnterLastDigitsDialogOpen: false, buzy: false, AddressLookupErrorText: '' }); }}>
                            AVBRYT
                        </LargeButton>
                    </DialogActions>
                </Dialog>
                <div style={{ backgroundColor: theme.palette.primary.main, color: '#FFF', padding: '20px' }} className='white-links'>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={10}>
                            <Icon name="profile" size={48} color="#FFFFFF" />
                            <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                {t('selfcare:item.changeaddress')}
                            </div>
                            {this.state.IsNorway && this.state.CustomerType === '10' && <div style={{ fontSize: '14px' }}>
                                <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.cannotchangeusername') }} />
                            </div>}
                            {this.state.IsNorway && this.state.CustomerType === '20' && <div style={{ fontSize: '14px' }}>
                                <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.cannotchangecompanyname') }} />
                            </div>}
                        </Grid>
                    </Grid>
                </div>
                <div>
                    {this.state.DisabledMessage && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{this.state.DisabledMessage}</div>}
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={10}>
                            {this.state.CanRetrieveAddress && <SmallButton onClick={() => { this.setState({ buzy: true }); this.dispatchState({ GetUpdatedAddress: true }); }} disabled={this.state.buzy || this.state.Disabled} style={{ marginTop: '10px', marginRight: '10px' }}>{t('selfcare:button.fetchaddressnationalregistry')}</SmallButton>}
                            <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:title.customerinfo')}</div>
                            <Grid container>
                                {this.state.CustomerType === '10' &&
                                    <TextField
                                        disabled
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        label={t('selfcare:label.firstname')}
                                        id="Firstname"
                                        name="Firstname"
                                        helperText=""
                                    />
                                }
                                {this.state.CustomerType === '10' &&
                                    <TextField
                                        disabled
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        label={t('selfcare:label.lastname')}
                                        id="Lastname"
                                        name="Lastname"
                                        className={classes.textField}
                                    />
                                }
                                {this.state.CustomerType === '10' &&
                                    <TextField
                                        disabled
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}

                                        label={t('selfcare:label.birthdate')}
                                        id="Birthdate"
                                        name="Birthdate"
                                    />
                                }
                                {this.state.CustomerType === '20' &&
                                    <TextField
                                        disabled
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        label={t('selfcare:label.companyname')}
                                        id="CompanyName"
                                        name="CompanyName"
                                        className={classes.textField}
                                    />
                                }
                                {this.state.CustomerType === '20' &&
                                    <TextField
                                        disabled
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        label={t('selfcare:label.organizationnumber')}
                                        id="OrgNo"
                                        name="OrgNo"
                                    />
                                }
                                <TextField
                                    disabled={this.state.buzy || this.state.Disabled}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label={t('selfcare:label.contactnumber')}
                                    id="ContactPhone"
                                    name="ContactPhone"
                                    type='tel'
                                    maxLength={ 8 }
                                    inputRef={(el) => { this.ContactPhone = el; }}
                                />
                                <TextFieldLowerCase
                                    disabled={this.state.buzy || this.state.Disabled}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label={t('selfcare:label.email')}
                                    id="EmailAddress"
                                    name="EmailAddress"
                                    maxLength={50}
                                    type='email'
                                    inputRef={(el) => { this.EmailAddress = el; }}
                                />
                            </Grid>
                            <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:label.address')}</div>
                            <Grid container>
                                <TextField
                                    disabled={this.state.buzy || this.state.Disabled}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label={t('selfcare:label.coname')}
                                    id="CoAddress"
                                    name="CoAddress"
                                    maxLength={30}
                                    inputRef={(el) => { this.CoAddress = el; }}
                                />
                                <TextField
                                    disabled={this.state.buzy || this.state.Disabled}
                                    label={t('selfcare:label.address')}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    id="AddressLine"
                                    name="AddressLine"
                                    inputRef={(el) => { this.AddressLine = el; }}
                                />
                                <TextField
                                    disabled={this.state.buzy || this.state.Disabled}
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label={t('selfcare:label.postalcode')}
                                    id="PostalCode"
                                    name="PostalCode"
                                    className={classes.textField}
                                    type='tel'
                                    maxLength={postcodelen}
                                    inputRef={(el) => { this.PostalCode = el; }}
                                    afterChange={(value) => { this.dispatchState({ Lookup: value }); }}
                                />
                                <TextField
                                    disabled
                                    localState={this.state}
                                    setLocalState={this.setState.bind(this)}
                                    label={t('selfcare:label.postalcity')}
                                    id="City"
                                    name="City"
                                />
                            </Grid>
                            <Grid container direction="column" justifyContent="space-around" alignItems="center">
                                <div style={{ paddingTop: '20px' }}>
                                    <LargeButton onClick={() => { this.handleSave(); }} disabled={this.state.buzy || this.state.Disabled} style={{ marginRight: '10px' }}>{t('selfcare:button.update')}</LargeButton>
                                    <LargeButton id='cancel' variant="text" color="secondary" disabled={this.state.buzy} onClick={() => { this.props.handleClose(); }}>{t('selfcare:button.cancel')}</LargeButton>
                                </div>
                                {this.state.buzy &&
                                    <Grid item>
                                        <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}
ChangeAddress.propTypes = {
};

export default compose(
    withTranslation(),
)(withAITracking(reactPlugin, ChangeAddress));



